import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { ICart, ICartItem } from "projects/shared/models/interfaces/cart.model";

export const CartActions = createActionGroup({
  source: 'Cart',
  events: {
    // ! Initializing
    'Initialize Cart': props<{ initialized: boolean }>(),
    // ! Get Actions
    'Get Cart Data': props<{ cart: ICart }>(),
    'Get Cart Products': props<{ items: ICartItem[] }>(),
    // ! Update Actions
    'Update Cart': props<{ cart: ICart }>(),
    'Merge Cart Items': props<{ items: ICartItem[] }>(),
    'Add Item': props<{ item: ICartItem }>(),
    'Update Cart Item': props<{ item: ICartItem }>(),
    'Remove Item': props<{ id: string }>(),
    'Clear Cart': emptyProps(),
    // ! Status Side Effect Of Actions
    'Get Cart Success': props<{ getCartSuccess: string }>(),
    'Get Cart Failure': props<{ getCartFailure: string }>(),
    'Update Cart Success': props<{ updateCartSuccess: string }>(),
    'Update Cart Failure': props<{ updateCartFailure: string }>(),
    // ! Clear Status
    'Clear Cart Error': emptyProps(),
    'Clear Cart Success': emptyProps(),
  }
})